import { OnInit } from "@angular/core";
var FileComponent = /** @class */ (function () {
    function FileComponent() {
    }
    FileComponent.prototype.ngOnInit = function () { };
    return FileComponent;
}());
export { FileComponent };
